document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

window.addEventListener('DOMContentLoaded', () => {
  // --- Video Background Logic ---
  const mainVideos = document.querySelectorAll('.jm-bg-video:not(.jm-splash-video)');
  const splashVideo = document.querySelector('.jm-splash-page .jm-bg-video');
  const audioToggle = document.querySelector('.jm-audio-toggle');

  // Ensure all videos start muted and playing
  document.querySelectorAll('video').forEach(v => {
    v.muted = false;
    v.volume = 0.5;
    const playPromise = v.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => { /* Silent fail to avoid showing controls */ });
    }
  });

  // Set initial state of audio toggle button
  if (audioToggle && mainVideos.length > 0) {
    audioToggle.classList.add('is-unmuted');
  }

  // Main Audio Toggle (Only for non-splash videos)
  if (audioToggle) {
    audioToggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (mainVideos.length > 0) {
        const currentlyMuted = mainVideos[0].muted;
        mainVideos.forEach(v => {
          v.muted = !currentlyMuted;
          if (v.paused) v.play();
        });
        audioToggle.classList.toggle('is-unmuted', currentlyMuted);
      }
    });
  }

  // --- Splash Page Transition Logic ---
  const splash = document.getElementById('SplashPage');
  const enterBtn = document.getElementById('EnterButton');

  if (splash && enterBtn) {
    enterBtn.addEventListener('click', () => {
      splash.classList.add('is-hidden');
      sessionStorage.setItem('jm_entered', 'true');
      
      // Ensure main videos are playing after splash
      mainVideos.forEach(v => {
        if (v.paused) v.play();
      });

      // Pause and "kill" all splash videos
      document.querySelectorAll('.jm-splash-video').forEach(v => {
        v.pause();
        v.muted = true;
      });
      
      // Remove hidden style after animation if any
      setTimeout(() => {
        splash.style.display = 'none';
      }, 600);
    });
  }

  // --- Product Gallery Logic ---
  const thumbnails = document.querySelectorAll('.jm-thumbnail');
  const mainImage = document.querySelector('.jm-main-media img');

  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const newUrl = thumb.getAttribute('data-full-url');
      if (mainImage && newUrl) {
        mainImage.src = newUrl;
        thumbnails.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      }
    });
  });

  // --- Product Variant Selection Logic ---
  const productJsonEl = document.querySelector('[id^="ProductJson-"]');
  if (productJsonEl) {
    const product = JSON.parse(productJsonEl.innerHTML);
    const selectors = document.querySelectorAll('.jm-single-option-selector');
    const hiddenIdInput = document.querySelector('input[name="id"]');
    const priceDisplay = document.querySelector('[id^="ProductPrice-"]');
    const addToCartBtn = document.querySelector('.jm-add-to-cart');
    const btnText = document.querySelector('.jm-button-text');

    const updateVariant = () => {
      let selectedOptions = [];
      selectors.forEach(s => selectedOptions.push(s.value));

      const foundVariant = product.variants.find(v => {
        return v.options.every((opt, i) => opt === selectedOptions[i]);
      });

      if (foundVariant) {
        hiddenIdInput.value = foundVariant.id;
        if (priceDisplay) {
          priceDisplay.innerHTML = Shopify.formatMoney(foundVariant.price, "{{ shop.money_format }}");
        }
        if (foundVariant.available) {
          addToCartBtn.disabled = false;
          if (btnText) btnText.innerText = "Add to cart";
        } else {
          addToCartBtn.disabled = true;
          if (btnText) btnText.innerText = "Sold out";
        }
      } else {
        addToCartBtn.disabled = true;
        if (btnText) btnText.innerText = "Unavailable";
      }
    };

    selectors.forEach(s => s.addEventListener('change', updateVariant));
  }
});
